module.exports = bamShared.btmUserManager;